<template>
  <div
    style="width: 100%"
    class="mx-2"
  >
    <v-col cols="12">
      <app-title texto="SELEÇÃO DAS UNIDADES" />
    </v-col>
    <v-col cols="12">
      <selecao-unidade v-model="filtro.selecaoUnidade" />
    </v-col>
    <v-col cols="12">
      <app-title texto="CADASTRO" />
    </v-col>
    <v-col cols="12">
      <filtro-base :value="filtro.pessoal" />
    </v-col>
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import SelecaoUnidade from '@/components/monitoramento/perfil/SelecaoUnidade';
import FiltroBase from '@/components/monitoramento/perfil/filtro/base/FiltroBase';
import FiltroPerfil from '@/modules/filtroPerfil';

export default {
  name: 'FiltroCadastro',

  components: { AppTitle, SelecaoUnidade, FiltroBase },

  data() {
    return {
      filtro: {
        selecaoUnidade: {
          id: 'unidades',
          tipo: 'unidade',
          habilitado: true,
          unidades: [],
          lista: this.$store.state.unidade.unidades,
          comissao: this.$store.state.auth.comissao,
          macro: false,
          categoria: null,
          colunas: 12,
          filhos: [],
        },
        pessoal: {
          titulo: 'DADOS PESSOAIS',
          habilitado: true,
          filhos: [
            {
              id: 'deficiente',
              tipo: 'confirm',
              titulo: 'Possui alguma condição de deficiência?',
              habilitado: false,
              opcoes: [
                { nome: 'Sim', valor: true },
                { nome: 'Não', valor: false },
              ],
              opcao: null,
              horizontal: true,
              colunas: 6,
              filhosDependentes: true,
              filhos: [
                {
                  id: 'deficiencias',
                  tipo: 'select',
                  titulo: 'Condições de Deficiência',
                  habilitado: false,
                  selecionado: [],
                  lista: this.$store.state.perfil.deficiencias,
                  itemText: 'nome',
                  icone: 'accessible',
                  multiplo: true,
                  todas: true,
                  colunas: 6,
                  filhos: [],
                },
              ],
            },
          ],
        },
      },
    };
  },

  watch: {
    filtro: {
      handler(value) {
        const filtroDeficiente = FiltroPerfil.get('deficiente', value.pessoal.filhos);
        const filtroDeficiencias = FiltroPerfil.get('deficiencias', filtroDeficiente.filhos);

        const retorno = {
          unidades: {
            selecionado: value.selecaoUnidade.unidades,
            macro: value.selecaoUnidade.macro,
            tituloVisualizacao: 'Unidades',
            visualizacao: value.selecaoUnidade.unidades.map((u) => u.sigla).join(', '),
            habilitado: value.selecaoUnidade.unidades.length > 0,
          },
          deficiente: FiltroPerfil.getRetorno(filtroDeficiente),
          deficiencias: FiltroPerfil.getRetorno(filtroDeficiencias),
        };
        retorno.habilitado = FiltroPerfil.getHabilitado(retorno);
        this.$emit('return', retorno.habilitado ? retorno : null);
      },
      deep: true,
    },
  },
};
</script>
